import React, { useEffect, useState } from 'react'

const Ticker = ({ handleWithResendSMS }) => {
  const [counter, setCounter] = useState(60)

  useEffect(() => {
    const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000)
    return () => clearInterval(timer)
  }, [counter])

  return (
    <div>
      {counter === 0 ? (
        <div>
          <span 
            onClick={() => {
              handleWithResendSMS()
              setCounter(5)
            }}
            className='ticker_link'
          >
            Reenviar código
          </span>
        </div>
      ) : (
        <div>Contador: {counter}</div>
      )}
    </div>
  )
}

export default Ticker
